{
  "completed": "Voltooid: ",
  "current": "Actueel: ",
  "notCompleted": "Niet voltooid: ",
  "steplist": "Stappenlijst"
}
